
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[version]/live",
      function () {
        return require("private-next-pages/docs/[version]/live.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/[version]/live"])
      });
    }
  